module.exports = __webpack_public_path__ + "static/media/logo.bbaac18c.svg";